import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "data-ingestion-history-menu__header" };
const _hoisted_2 = { class: "data-ingestion-history-menu__items" };
const _hoisted_3 = ["data-cy"];
import { ref, computed, watch } from 'vue';
import { formatDate } from '@/utilities/formatters';
import { useMixpanelDataIngestionHistory, useMixpanelDataIngestionPagination, } from '@/utilities/mixpanel/dataIngestionHistory';
import DataIngestionHistoryMenuSkeleton from './DataIngestionHistoryMenuSkeleton.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionHistoryMenu',
    props: {
        items: {},
        totalCount: {},
        error: { type: Boolean },
        loading: { type: Boolean },
        resetPagination: { type: Boolean }
    },
    emits: ["itemSelected", "fetchData"],
    setup(__props, { emit }) {
        const props = __props;
        const pagination = ref(1);
        const menuDateSelected = ref(false);
        const menuDateSelectedIndex = ref(0);
        watch(() => props.resetPagination, () => {
            if (props.resetPagination) {
                pagination.value = 1;
                menuDateSelectedIndex.value = 0;
            }
        });
        const getTotalCount = computed(() => {
            return props.totalCount;
        });
        const changePage = (page) => {
            menuDateSelected.value = false;
            pagination.value = page;
            useMixpanelDataIngestionPagination('view_integrations_data-ingestion-history_change-page', page);
            emit('fetchData', page);
        };
        const selectedDate = (item, index) => {
            menuDateSelected.value = true;
            menuDateSelectedIndex.value = index;
            useMixpanelDataIngestionHistory('view_integrations_data-ingestion-history_select-date', item[0], item[1].status);
            emit('itemSelected', item);
        };
        const getColor = (item) => {
            const colors = {
                error: '#E74C3C',
                warning: '#F1C40F',
                success: '#2ECC71',
                warning_high: '#E67E22',
            };
            return colors[item];
        };
        return (_ctx, _cache) => {
            const _component_el_timeline_item = _resolveComponent("el-timeline-item");
            const _component_el_timeline = _resolveComponent("el-timeline");
            const _component_el_menu_item = _resolveComponent("el-menu-item");
            const _component_el_menu = _resolveComponent("el-menu");
            const _component_el_pagination = _resolveComponent("el-pagination");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-ingestion-history-menu", { 'data-ingestion-history-menu--loading': props.loading }])
            }, [
                (!props.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('data-ingestion-history.title')), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('data-ingestion-history.description')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_2, [
                            (props.items)
                                ? (_openBlock(), _createBlock(_component_el_menu, {
                                    key: 0,
                                    collapse: true,
                                    "default-active": "0"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                key: index,
                                                class: _normalizeClass(`${(index === 0 && !menuDateSelected.value) || (menuDateSelected.value && menuDateSelectedIndex.value === index)
                                                    ? 'is-active'
                                                    : 'not-active'} menu-${index} `),
                                                index: index,
                                                "data-cy": `data-ingestion-history-menu-item-${index}`,
                                                onClick: ($event) => (selectedDate(item, index))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_timeline, null, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                                color: getColor(item[1].status),
                                                                key: index
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("strong", {
                                                                        class: _normalizeClass(`data-ingestion-history-menu--${item[1].status}`),
                                                                        "data-cy": `data-ingestion-history-menu-date-${index}`
                                                                    }, _toDisplayString(_unref(formatDate)(item[0], 'DD MMM YYYY')), 11, _hoisted_3)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["color"]))
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1032, ["class", "index", "data-cy", "onClick"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            (getTotalCount.value > 10 || props.error)
                                ? (_openBlock(), _createBlock(_component_el_pagination, {
                                    key: 1,
                                    class: "data-ingestion-history-menu__pagination",
                                    "data-cy": "data-ingestion-history-menu-pagination",
                                    background: "",
                                    layout: "prev, pager, next",
                                    "current-page": pagination.value,
                                    "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event) => ((pagination).value = $event)),
                                    "pager-count": 3,
                                    small: true,
                                    total: getTotalCount.value,
                                    onCurrentChange: changePage
                                }, null, 8, ["current-page", "total"]))
                                : _createCommentVNode("", true)
                        ])
                    ], 64))
                    : (_openBlock(), _createBlock(DataIngestionHistoryMenuSkeleton, { key: 1 }))
            ], 2));
        };
    }
});
